export const removeQueryParams = (paramName: string) => {
	const params = new URLSearchParams(window.location.search);
	params.delete(paramName);
	const newSearch = params.toString();
	const newUrl = newSearch
		? `${window.location.pathname}?${newSearch}`
		: window.location.pathname;
	window.history.replaceState(null, "", newUrl);
};

export const updateQueryParams = (paramName: string, paramValue: string) => {
	const params = new URLSearchParams(window.location.search);
	params.set(paramName, paramValue.toString());
	const newUrl = `${window.location.pathname}?${params.toString()}`;
	window.history.replaceState(null, "", newUrl);
};
